import Lottie from "lottie-react"

import loading from "@/assets/lottie/loader.json"

export const LoadingSpinner: React.FC<{ className: string }> = ({ className }) => (
  <div className="flex items-center justify-center h-full">
    <Lottie animationData={loading} loop={true} className={className} />
  </div>
)
